import { BoxGeometry, DoubleSide, Mesh, MeshBasicMaterial, type Scene, type Vector3 } from 'three';

export type ZoneKind = 'start' | 'checkpoint' | 'end' | 'boost' | 'teleport';

export interface ZoneDef {
  kind: ZoneKind;
  /** Box center, world units. */
  center: Vector3;
  /** Full box extents per axis. */
  size: Vector3;
  /** `boost` only: factor applied to horizontal velocity on entry (e.g. 1.2). */
  boost?: number;
  /** `teleport` only: destination feet position; velocity is preserved. */
  dest?: Vector3;
}

export function zoneContains(zone: ZoneDef, point: Vector3): boolean {
  return (
    Math.abs(point.x - zone.center.x) <= zone.size.x / 2 &&
    Math.abs(point.y - zone.center.y) <= zone.size.y / 2 &&
    Math.abs(point.z - zone.center.z) <= zone.size.z / 2
  );
}

const ZONE_COLORS: Record<ZoneKind, number> = {
  start: 0x4caf50,
  checkpoint: 0x42a5f5,
  end: 0xef5350,
  boost: 0xffd54a,
  teleport: 0xab47bc,
};

/** Renders zones as translucent volumes. Visual only — never colliders. */
export function addZoneMeshes(scene: Scene, zones: ZoneDef[]): void {
  for (const zone of zones) {
    const mesh = new Mesh(
      new BoxGeometry(zone.size.x, zone.size.y, zone.size.z),
      new MeshBasicMaterial({
        color: ZONE_COLORS[zone.kind],
        transparent: true,
        opacity: 0.18,
        side: DoubleSide,
        depthWrite: false,
      }),
    );
    mesh.position.copy(zone.center);
    scene.add(mesh);
  }
}
